<template>
  <div>
    <transition name="overlay-fade"><div class="overlay" v-if="showOverlay"></div></transition>
    <div class="mt-3 mb-2 pr-2 pl-2">
      <div class="d-flex align-items-center">
        <h1 class="title-section-info">Checkout</h1>
        <b-form-checkbox v-if="isAdmin" switch class="checkbox-switch switch-webhook checkbox-company"
          v-model="form.activated" disabled>
          <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
        </b-form-checkbox>
        <div v-else class="d-flex align-items-center">
          <span class="table_dot--company mr-50" :class="getStatusClass(form.activated)"></span>
          <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 mt-2 mb-3">
      <p class="m-0">Personaliza tu <strong>'Checkout'</strong> para que refleje la identidad de tu tienda. Elige colores y define las opciones de entrega disponibles. Revisa una vista previa antes de activarlo.</p>
    </div>

    <b-card>
      <div class="tab-header-content">
        <b-tabs ref="checkoutTabs" v-model="activeTab" fill>
          <b-tab>
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 0 ? 'primary' : 'secondary'" class="mr-1">1</b-avatar>
              {{ $t('Colores') }}
            </template>
            <TabColorsPicker
              @colors-customized="onColorsCustomized"
              @continuar="onColorsContinuar"
              :badges-color="form.badges_color"
              :buttons-color="form.buttons_color"
              :can-continue="colorsCustomized"
            ></TabColorsPicker>
          </b-tab>
          <b-tab :disabled="!colorsCustomized">
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 1 ? 'primary' : 'secondary'" class="mr-1">2</b-avatar>
              {{ $t('Entrega') }}
            </template>
            <TabDelivery
              @continuar="onDeliveryContinuar"
              :is-loading="loading.awaiting"
              :initial-selected-home="selectedHome"
              :initial-selected-pudo="selectedPudo"
              :initial-free-shipping-home="freeShippingHome"
              :initial-free-shipping-pudo="freeShippingPudo"
              :initial-free-shipping-domicilio="freeShippingDomicilio"
              :initial-min-amount-domicilio="minAmountDomicilio"
            ></TabDelivery>
          </b-tab>
          <b-tab :disabled="!colorsCustomized">
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 2 ? 'primary' : 'secondary'" class="mr-1">3</b-avatar>
              {{ $t('Vista previa') }}
            </template>
            <TabPreview
              :selected-home="selectedHome"
              :selected-pudo="selectedPudo"
              :selected-delivery="selectedDelivery"
              :free-shipping-home="freeShippingHome"
              :free-shipping-pudo="freeShippingPudo"
              :free-shipping-domicilio="freeShippingDomicilio"
              :min-amount-domicilio="minAmountDomicilio"
              :badges-color="form.badges_color"
              :buttons-color="form.buttons_color"
              @guardar-y-activar="onSave"
            ></TabPreview>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>
<script>
import TabColorsPicker from './tabs/TabColorsPicker.vue'
import TabDelivery from './tabs/TabDelivery.vue'
import TabPreview from './tabs/TabPreview.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'TabCheckout',
  components: {
    TabColorsPicker,
    TabDelivery,
    TabPreview
  },
  data () {
    return {
      form: {
        activated: false,
        badges_color: '',
        buttons_color: ''
      },
      isAdmin: this.$store.getters['auth/isAdmin'],
      colorsCustomized: false,
      activeTab: 0,
      showOverlay: false,
      selectedHome: false,
      selectedPudo: false,
      selectedDelivery: true,
      freeShippingHome: false,
      freeShippingPudo: false,
      freeShippingDomicilio: false,
      minAmountDomicilio: null,
      loading: {
        awaiting: true
      },
      company_id: this.$route.params?.id
    }
  },
  computed: {
    ...mapGetters({
      checkout: 'getShopNameCheckout'
    })
  },
  watch: {
    checkout(val) {
      if (val && val.configuration) {
        this.form.activated = val.is_activated
        const colors = val.configuration.colors
        if (colors) {
          this.form.badges_color = colors.badge_color
          this.form.buttons_color = colors.button_color
        }
        const delivery = val.configuration.delivery_methods
        if (delivery) {
          if (delivery.pickup_tienda) {
            this.selectedHome = delivery.pickup_tienda.active
            if (delivery.pickup_tienda.free_pickup_tienda) {
              this.freeShippingHome = delivery.pickup_tienda.free_pickup_tienda.active
            }
          }
          if (delivery.pickup_punto) {
            this.selectedPudo = delivery.pickup_punto.active
            if (delivery.pickup_punto.free_pickup_punto) {
              this.freeShippingPudo = delivery.pickup_punto.free_pickup_punto.active
            }
          }
          if (delivery.shipping_home) {
            if (delivery.shipping_home.free_shipping_home) {
              this.freeShippingDomicilio = delivery.shipping_home.free_shipping_home.active
              this.minAmountDomicilio = Number(delivery.shipping_home.free_shipping_home.thresholds?.CLP) || null
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getCompanyShopName()
  },
  methods: {
    getCompanyShopName() {
      this.$store.dispatch('fetchService', {
        name: 'getShopNameCheckout',
        params: { company_id: this.company_id },
        onSuccess: () => this.loading.awaiting = false
      })
    },
    onSuccess() {
      this.$emit('continuar')
      this.loading.create = false
      this.loadingSpinner = false
    },
    onError() {
      this.loading.create = false
      this.loadingSpinner = false
    },
    putCheckoutSettings() {
      const queryParams = {
        shop_name: this.checkout.shopify_shop,
        is_activated: this.checkout.is_activated,
        configuration: {
          colors: {
            badge_color: this.form.badges_color,
            button_color: this.form.buttons_color
          },
          delivery_methods: {
            pickup_tienda: {
              active: this.selectedHome,
              free_pickup_tienda: { active: this.freeShippingHome }
            },
            pickup_punto: {
              active: this.selectedPudo,
              free_pickup_punto: { active: this.freeShippingPudo }
            },
            shipping_home: {
              active: this.selectedDelivery,
              free_shipping_home: {
                active: this.freeShippingDomicilio,
                thresholds: { CLP: this.minAmountDomicilio }
              }
            }
          }
        }
      }
      const params = { shop_name: this.checkout.shopify_shop }
      this.$store.dispatch('fetchService', {
        name: 'putSettingsCheckout',
        queryParams,
        params,
        onSuccess: (resp) => this.onSuccess(resp),
        onError: () => this.onError()
      })
    },
    getStatusClass(activated) {
      return activated ? 'table_dot--company-ok' : 'table_dot--company-inactivated'
    },
    goToTab(index) {
      this.activeTab = index
    },
    onColorsContinuar(payload) {
      this.form.badges_color = payload.badges_color
      this.form.buttons_color = payload.buttons_color
      this.goToTab(1)
    },
    onColorsCustomized(val) {
      this.colorsCustomized = val
    },
    onDeliveryContinuar(payload) {
      this.selectedHome = payload.selectedHome
      this.selectedPudo = payload.selectedPudo
      this.selectedDelivery = payload.selectedDelivery
      this.freeShippingHome = payload.freeShippingHome
      this.freeShippingPudo = payload.freeShippingPudo
      this.freeShippingDomicilio = payload.freeShippingDomicilio
      this.minAmountDomicilio = payload.minAmountDomicilio ? Number(payload.minAmountDomicilio) : null
      this.goToTab(2)
    },
    onSave() {
      this.putCheckoutSettings()
      this.activeTab = 0
      this.form.activated = this.checkout.is_activated
      this.$newSuccess('¡Se ha configurado con éxito la personalización tu Checkout!', 'Tus clientes verán tu tienda con el estilo que elegiste.', 'medium')
    }
  }
}
</script>
<style>
  .table_dot--company-ok{
    background-color:#1E8E3E
  }
  .table_dot--company-inactivated{
    background-color:#D9D9D9
  }
</style>